export enum searchBarFilter {
  FILTER_SELECTED = 'FILTER_SELECTED',
}
